<template>
	<div class="service">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onexport()">售后列表导出</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.date_type" placeholder="时间类型">
							<el-option label="申请时间" :value="1"></el-option>
							<el-option label="受理时间" :value="2"></el-option>
							<el-option label="确认退货时间" :value="3"></el-option>
						</el-select>
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.delivery_id" placeholder="实发快递" filterable size="small">
							<el-option label="实发快递" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="订单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.cfrom" placeholder="订单来源">
							<el-option label="订单来源" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_cfrom" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.service_status" placeholder="状态">
							<el-option label="售后状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_service_status"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.recv_name" placeholder="收件人"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.delivery_num" placeholder="快递单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.out_trade_no" placeholder="客户单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.recv_mobbile" placeholder="手机号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.refund_delivery_num" placeholder="退回快递单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.refund_reason" placeholder="退货原因">
							<el-option label="退货原因" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_service_reason" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.style_number" placeholder="款号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.buyer_mark" placeholder="标记">
							<el-option label="标记" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.mark" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.buyer_remark" placeholder="备注"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.seller_memo" placeholder="备忘"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border :cell-class-name="cellClassName" height="100%">
					<el-table-column label="订单编号/客户单号" min-width="150px" align="center" header-align="center"
						fixed="left">
						<template slot-scope="scope">
							<div @click="oncopy(scope.row.trade_no)">{{scope.row.trade_no}}</div>
							<div @click="oncopy(scope.row.out_trade_no)">{{scope.row.out_trade_no}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="recv_name" label="收货人" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="total_num" align="center" header-align="center" min-width="50px">
						<template slot="header" slot-scope="scope">
							<div>下单</div>
							<div>数量</div>
						</template>
					</el-table-column>
					<el-table-column prop="total_true_num" align="center" header-align="center" min-width="50px">
						<template slot="header" slot-scope="scope">
							<div>实发</div>
							<div>数量</div>
						</template>
					</el-table-column>
					<el-table-column prop="total_refund_num" align="center" header-align="center" min-width="50px">
						<template slot="header" slot-scope="scope">
							<div>退货</div>
							<div>数量</div>
						</template>
					</el-table-column>
					<el-table-column prop="refund_fee_for_seller" label="退货金额" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column label="实发快递" align="center" header-align="center" min-width="160px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_delivery" :key="k">
								<div>{{v.delivery_name}}</div>
								<div>
									{{v.delivery_num}}
									<span class="k" v-if="v.cfrom==1">快</span>
									<span class="j" v-if="v.cfrom==2">聚</span>
								</div>
								<el-popover width="470" trigger="click" @show="ongdd(v.id,1)" @hide="kdlist = []">
									<div class="kdbox">
										<el-table :data="kdlist" style="width: 100%">
											<el-table-column width="160" prop="time_str" label="时间"></el-table-column>
											<el-table-column width="300" prop="desc" label="地点和跟踪进度"></el-table-column>
										</el-table>
									</div>
									<div slot="reference" :class="oncp(v.delivery_status)">{{v.delivery_status_str}}</div>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="退货快递" align="center" header-align="center" min-width="160px">
						<template slot-scope="scope">
							<div>{{scope.row.delivery_name}}</div>
							<div @click="oncopy(scope.row.delivery_num)">{{scope.row.delivery_num}}</div>
							<el-popover width="470" trigger="click" @show="ongdd(scope.row.id,2)" @hide="kdlist = []">
								<div class="kdbox">
									<el-table :data="kdlist" style="width: 100%">
										<el-table-column width="160" prop="time_str" label="时间"></el-table-column>
										<el-table-column width="300" prop="desc" label="地点和跟踪进度"></el-table-column>
									</el-table>
								</div>
								<div slot="reference" :class="oncp(scope.row.delivery_status)">{{scope.row.delivery_status_str}}</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="申请售后时间" align="center" header-align="center"
						min-width="110px" width="110px">
					</el-table-column>
					<el-table-column prop="agree_time_str" label="受理时间" align="center" header-align="center"
						min-width="110px" width="110px">
					</el-table-column>
					<el-table-column label="问题类型" align="center" header-align="center" min-width="150px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_detail" :key="k">
								<div>{{v.product_style_number}}|{{v.product_size}}|{{v.num}}</div>
								<div>{{v.refund_reason_str}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="service_status_str" label="售后状态" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="agree_remark" label="备注" align="center" header-align="center"
						min-width="150px">
					</el-table-column>
					<el-table-column prop="seller_remark" label="备注/备忘/代理备忘" align="center" header-align="center"
						min-width="150px">
						<template slot-scope="scope">
							<i class="hq el-icon-s-flag" v-if="scope.row.order.seller_mark"
								:style="'color:'+onmark(scope.row.order.seller_mark)"></i>
							<!-- 备注 -->
							<p>{{scope.row.order.seller_remark}}</p>
							<!-- 备忘 -->
							<p :style="'color:'+onmark(scope.row.order.seller_mark)">{{scope.row.order.seller_memo}}</p>
							<!-- 渠道备忘 -->
							<p v-if="scope.row.order.buyer_memo_show_seller == 1">{{scope.row.order.buyer_memo}}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" width="110px" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="operation_i">
								<div>
									<span @click="oninfo(scope.row)">详细</span>
									<span @click="onservicedetails(scope.row)">处理</span>
								</div>
								<div>
									<el-dropdown @command="handleCommand($event,scope.row.order)" placement="bottom">
										<span>标记</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item :command="0">取消</el-dropdown-item>
											<el-dropdown-item :command="v.id" v-for="(v,k) in appdata.list.mark"
												:key="k"><i :style="'color:'+v.color">{{v.name}}</i></el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>

									<span @click="onmemo(scope.row)">备忘</span>
								</div>
								<div class="simg">
									<el-tooltip :content="scope.row.buyer_qq" placement="bottom" effect="light">
										<img src="../../assets/image/qq.png" @click="oncopy(scope.row.buyer_qq)">
									</el-tooltip>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		<el-dialog title="订单详情" :visible.sync="detailsVisible" width="80%" :before-close="onclose">
			<orderdetails :checkobj="checkedobj" v-if="detailsVisible" @odload="onbolist()"></orderdetails>
		</el-dialog>

		<el-dialog title="订单售后详情" :visible.sync="sdVisible" width="80%" :before-close="onclose2">
			<servicedetails :checkobj="checkedobj" v-if="sdVisible" @odload="onbolist()"></servicedetails>
		</el-dialog>

		<el-dialog title="订单备忘" :visible.sync="memoVisible" width="60%" :before-close="onclose3">
			<memo ref="memo" :checkobj="checkedobj" v-if="memoVisible" @ondata="onmemodata"></memo>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose3">取消</el-button>
				<el-button type="primary" @click="onsubmemo()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Service',
		data() {
			return {
				formfilter: {
					shop_id: "",
					date_type: 1,
					trade_no: "",
					service_status: "",
					mydate: [],
					btime: "",
					etime: "",
					brand: "",
					delivery_id: "",
					cfrom: "",
					recv_name: "",
					delivery_num: "",
					out_trade_no: "",
					recv_mobbile: "",
					refund_delivery_num: "",
					refund_reason: "",
					style_number: "",
					buyer_mark: "",
					buyer_memo: ""
				},
				list: [],
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,

				qudao: [],
				checkedobj: {},

				detailsVisible: false,
				sdVisible: false,
				memoVisible: false,

				kdlist: [],
			}
		},

		inject: ['appdata', 'oncopy','formatDate'],

		mounted() {
			this.onqudao();
			// this.onbolist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		watch: {
			'$route.query': {
				handler(newQuery, oldQuery) {
					if (Object.keys(this.$route.query).length > 0) {
						for (let key in this.$route.query) {
							if (key == 'service_status') {
								this.formfilter[key] = Number(this.$route.query[key]);
							} else {
								this.formfilter[key] = this.$route.query[key];
							}
						}
					} else {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						this.formfilter.mydate = [this.formatDate(start), this.formatDate(end)];
					};
					
					this.onbolist();
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},

		methods: {
			handleCurrentChange() {
				this.onbolist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onbolist();
			},

			onfilter() {
				this.page = 1;
				this.onbolist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					date_type: 1,
					trade_no: "",
					service_status: "",
					mydate: [],
					btime: "",
					etime: "",
					brand: "",
					delivery_id: "",
					cfrom: "",
					recv_name: "",
					delivery_num: "",
					out_trade_no: "",
					recv_mobbile: "",
					refund_delivery_num: "",
					refund_reason: "",
					style_number: "",
					buyer_mark: "",
					buyer_memo: ""
				};
				this.page = 1;
				this.onbolist();
			},

			onbolist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				if(obj.date_type == 1) {
					obj.btime = obj.mydate[0];
					obj.etime = obj.mydate[1];
				}
				
				if(obj.date_type == 2) {
					obj.bagree_time = obj.mydate[0];
					obj.eagree_time = obj.mydate[1];
				}
				
				if(obj.date_type == 3) {
					obj.brefund_time = obj.mydate[0];
					obj.erefund_time = obj.mydate[1];
				}
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/seller_service_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					if (row.order_status == 7) {
						return "o_row"
					}
				
					if (row.order_status == 11) {
						return "y_row"
					}
					
				
					var n = row.total_num ? row.total_num:0;
					var t = row.total_true_num ? row.total_true_num:0;
					if (n > t) {
						return "yellor_row"
					}
				}
			},

			oninfo(obj) {
				this.checkedobj = obj;
				this.detailsVisible = true;
			},

			onclose() {
				this.checkedobj = {};
				this.detailsVisible = false;
			},

			onservicedetails(obj) {
				this.checkedobj = obj;
				console.log(this.checkedobj);
				this.checkedobj.service = {
					service_id: obj.id
				};
				this.sdVisible = true;
			},

			onclose2() {
				this.checkedobj = {};
				this.sdVisible = false;
			},

			//备忘
			onmemo(obj) {
				this.checkedobj = obj.order;
				this.memoVisible = true;
			},

			onclose3() {
				this.checkedobj = {};
				this.memoVisible = false;
			},

			onsubmemo() {
				this.$refs.memo.ondata();
			},

			onmemodata(data) {
				this.$axios.post('api/user/seller_memo', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose3();
						this.onbolist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},


			onmark(id, n) {
				var color = "#000";
				if (this.appdata.list.mark) {
					this.appdata.list.mark.forEach((v, k) => {
						if (v.id == id) {
							color = v.color
						}
					})
				}
				return color;
			},

			handleCommand(val, data) {
				var obj = {
					trade_no: data.trade_no,
					seller_mark: val,
					seller_memo: data.seller_memo,
					seller_memo_show_buyer: data.seller_memo_show_buyer
				};
				this.onmemodata(obj);
			},

			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				if(obj.date_type == 1) {
					obj.btime = obj.mydate[0];
					obj.etime = obj.mydate[1];
				}
				
				if(obj.date_type == 2) {
					obj.bagree_time = obj.mydate[0];
					obj.eagree_time = obj.mydate[1];
				}
				
				if(obj.date_type == 3) {
					obj.brefund_time = obj.mydate[0];
					obj.erefund_time = obj.mydate[1];
				}
				this.$axios.post('api/user/seller_service_export',obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ongdd(id,n) {
				var url = "";
				var obj = {};
				obj.id = id;
				if(n == 1) {
					url="api/user/get_delivery_detail"
				}
				if(n == 2) {
					url="api/user/get_service_delivery_detail"
				}
				this.$axios.post(url, obj).then(res => {
					if (res.data.code == 0) {
						this.kdlist = res.data.data.content.reverse();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncp(i) {
				if(i) {
					if(i == 1 || i == 2 || i == 3) {
						return 'cp ysy'
					}
					
					if(i == 4 || i == 5) {
						return 'cp ysb'
					}
				}else {
					return 'cp'
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.service {
		height: calc(100% + 54px);
	}

	.filterty .el-date-editor {
		width: 250px;
	}
	
	.filterty .el-date-editor {
		width: 250px;
	}
	
	.filterty .el-select {
		width: 120px;
	}
	
	.filterty .el-input {
		width: 120px;
	}
	
	.filterty .el-date-editor {
		width: 250px;
	}

	.simg {
		width: 100%;
		display: flex;
		justify-content: center;

		img {
			width: 25px;
			height: 25px;
		}
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.kdbox {
		width: 470px;
		height: 400px;
		overflow: auto;
	}

	.cp {
		cursor: pointer;
		text-decoration: underline;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/service.vue